
import * as types from "./types";
import * as RoyaltyModuleTypes from "../types";
import { JSON_STRING, HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { AccountsService } from "../../services/accounts.service";
import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";
import router from '../../../../router';
import { fetchPropertiesWithArgs, fetchPropertiesWithArgsFlat } from "../../../../utility/fp";
import { fromPairs } from "lodash";
import { RoyaltyStoreNamespace } from "..";


const NavTabModule = getNavTabModule(types.AccountsDetails, 'accountsDetails');
export const accountsRoyaltyActions = {
  async [types.AccountsRoyaltyData.FETCH.ALL]({ commit, getters, dispatch }, payload) {

  },
  async [types.AccountsList.SET.ALL]({ commit, getters }, payload) {
    commit(types.AccountsList.SET.ALL, {
      ...getters.accountsList,
      royalty_accounts: payload
    });
  },
  async [types.AccountsList.FETCH.ALL]({ commit, getters, state }, payload) {
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;

    let res;

    if (searchMode == 'none') {
      if (start == 0) {
        res = await AccountsService.getAccounts({ start });
        commit(types.AccountsList.SET.ALL, res.data);
      } else {
        res = await AccountsService.getAccounts({ start });
        commit(types.AccountsList.SET.ALL, {
          ...getters.accountsList,
          royalty_accounts: [
            ...getters.accountsList?.royalty_accounts,
            ...res.data.royalty_accounts,
          ]
        });

        // Setting EOL
        if (!(res?.data?.royalty_accounts?.length > 0)) {
          return EOL_REACHED;
        }
      }

    } else if (searchMode == 'basic') {
      const { searchString } = basicFilter;

      res = await AccountsService.searchAccounts(searchString, start);

      if (start == 0) {
        commit(types.AccountsList.SET.ALL, {
          ...getters.accountsList,
          royalty_accounts: res.data.royalty_accounts
        });
      } else {
        commit(types.AccountsList.SET.ALL, {
          ...getters.accountsList,
          royalty_accounts: [
            ...getters.accountsList.royalty_accounts,
            ...res.data.royalty_accounts
          ]
        });
      }


      // Setting EOL
      if (!(res?.data?.royalty_accounts?.length > 0)) {
        return EOL_REACHED;
      }
    }
    else if (searchMode == 'advanced') {

      res = await AccountsService.fetchAdvancedSearch({ ...searchFilter, offset: start });

      if (start == 0) {
        commit(types.AccountsList.SET.ALL, {
          ...getters.accountsList,
          royalty_accounts: res.data.royalty_accounts
        });
      } else {
        commit(types.AccountsList.SET.ALL, {
          ...getters.accountsList,
          royalty_accounts: [
            ...getters.accountsList.royalty_accounts,
            ...res.data.royalty_accounts
          ]
        });
      }
      // Setting EOL
      if (!(res?.data?.royalty_accounts?.length > 0)) {
        return EOL_REACHED;
      }
    }
  },
  async [types.AccountsList.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log({payload});
    // return;

    const {kVal, name, value} = payload;
    
    const { itemID, colorPropertyName, colorPropertyValue, colorValue, colorName } = payload;
    // console.log({ itemID, colorPropertyName, colorPropertyValue, colorValue, colorName })
    
    if (getters.accountsDetails && getters.accountsDetails != null && getters.accountsDetails[kVal] !== undefined) {
      NavTabHelper.updateSingleNavTabDetails(kVal, raDetailsOBj => {
        return {
          ra: {
            ...raDetailsOBj.ra,
            [name]: value,
          }
        };
      });
    }
    
    const mod = await MHTTPCL.modifyJSON(undefined, kVal, name, value, 'l_royalty_accounts');

    // getters.releasesCatalogData.releases.push(releaseDetails.data.release)

    commit(types.AccountsList.SET.ALL, {
      ...getters.accountsList,
      royalty_accounts: getters.accountsList.royalty_accounts.map(e => {
        if (e.royalty_account_id === kVal) {
          return {
            ...e,
            [name]: value,
          }
        }

        return { ...e }
      }),

    });
  },
  // Show Sidewindow
  async [types.AccountsDetails.FETCH.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, account, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "royalty_account_id";
    const itemName = "account";
    const item = payload[itemName];



    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "accountsDetails";
    const DetailsAction = types.AccountsDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });


    await dispatch(types.AccountsDetails.FETCH.PARTIAL, {
      properties: [
        'get_royalty_account_setup',
        'get_royalty_account_contracts',
        'get_royalty_account_statements',
        'royalty_account_balances',
        //'get_royalty_account_contracts',
        //'royalty_account_balances',
        // 'get_related_ext_users',


        // Only needed for Contact_ID field ... It seems
        //'get_royalty_account_statements',

        // Only Needed for internal_notes it seems
        // Now that's Available in the Order Details Tab Summary
        // No Need for orderline_pack_status
        //'new_contract_form_data',

        // 'order_details_tab_overview',
        // 'order_details_tab_orderlines',
        // 'get_orderlines',

        // 'order_details',
        // 'order_details_tab_overview',
        // 'order_details_tab_summary',
        // 'get_delivery_address',
        // 'get_backorders',
        // 'order_details_tab_orderlines',
        // 'get_orderlines',
        // 'order_details_tab_packing_shipping',
        // 'packing_orderlines',
      ], royalty_account_id: account.royalty_account_id,
      parallel: false,
    });



    // HTTP Req
    // let detailsData = await HttpClient.mergeRequests([
    //   AccountsService.fetchRoyaltyAccountsDetailsTabSetup(account.royalty_account_id),
    //   AccountsService.get_royalty_account_contracts(account.royalty_account_id),
    //   AccountsService.fetchRoyaltyAccountsDetailsTabBalances(account.royalty_account_id),
    //   AccountsService.fetchRoyaltyExternalUsers(account.royalty_account_id),

    // ]);
    const detailsExternalUsers = await HttpClient.mergeRequests([
      AccountsService.fetchRoyaltyExternalUsers(account.royalty_account_id)
    ]);
    // const detailsData1 = await HttpClient.mergeRequests([
    //   AccountsService.get_royalty_account_statements(account.royalty_account_id)
    // ]);
    const detailsData2 = await HttpClient.mergeRequests([
      AccountsService.fetchNewContractFormData()
    ]);
    //const statement_data = detailsData1?.royalty_periods || [];
    const mechanical_rates_empty = detailsData2?.mechanical_rates_empty || false;
    // detailsData.account = detailsData.ra;
    // console.log("detailsData", detailsData);

    // DBox
    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, account) => {
        return {
          ...account,
          // ...detailsData,
          mechanical_rates_empty,
          ...detailsExternalUsers
          // loading: false,

        };
      }
    );
  },

  async [types.AccountsDetails.FETCH.PARTIAL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { properties, royalty_account_id, parallel, setnull } = payload;
    console.log(":::::::::::::", "FETCH PARTIAL", { properties, royalty_account_id, parallel, setnull })
    await fetchPropertiesWithArgsFlat(NavTabHelper, AccountsService, properties, [royalty_account_id], parallel, setnull);
  },

  // Left NavItem child details
  ...NavTabModule.implementActions(
    "royalty_account_id",
    "royalty_accounts/royalty_account_id/tab",
    "royalty_accounts",
    () => router,
    "royalty",
    (value, key) => {
      return {
        title:
          value && value.royalty_account && value.royalty_account.royalty_account_name
            ? value.royalty_account.royalty_account_name
            : key,
        full_title:
          value && value.royalty_account && value.royalty_account.royalty_account_name
            ? value.royalty_account.royalty_account_name
            : key
      };
    }
  ),



  async [types.AccountsList.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const nextAccountsList = await AccountsService.removeAccounts(payload.royalty_account_id);
    commit(types.AccountsList.DELETE.SINGLE, payload);
  },
  // Start Action of Updating single Object -- Accounts Items
  async [types.AccountsDetailsItems.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("Setup - Actions payload ", payload);

    const { name, value, selectedAccountDetails } = payload;
    const { account } = selectedAccountDetails;
    const { royalty_account_id } = account;

    const key = "account_pos_id";
    const kVal = item[key];
    const table = "l_contracts";

    NavTabHelper.updateSingleNavTabDetails(royalty_account_id, accountsDetailsObj => {
      console.log("accountsDetailsObj ", accountsDetailsObj);
      return {
        account: accountsDetailsObj.account.map(e => {
          if (e.contract_pos_id == item.contract_pos_id) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedLabel = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },
  // End Contract Items

  // Action of Updating single Object
  async [types.AccountsDetails.UPDATE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("update payload ", payload);

    const { name, value, nvps, selectedAccountDetails,
      path,
      table,
      primaryKey,
      kVal,
      noDatabaseUpdate,
    } = payload;

    const { account } = selectedAccountDetails;
    const { royalty_account_id } = account;

    // Detects if It is indeed an Array of Key Value Pairs. Each Key Value pairs must be an Array containing 2 elements. The First Element must be a string and the second element can be anything
    function isValidKeyValuePairs(array) {
      // Check if input is an array
      if (!Array.isArray(array)) {
        return false;
      }

      // Check each element in the array
      for (let i = 0; i < array.length; i++) {
        const pair = array[i];

        // Check if element is an array with 2 elements
        if (!Array.isArray(pair) || pair.length !== 2) {
          return false;
        }

        // Check if first element of pair is a string
        if (typeof pair[0] !== 'string') {
          return false;
        }
      }

      // If all checks pass, return true
      return true;
    }
    if (path) {
      NavTabHelper.updateSingleNavTabDetailsWithPath(royalty_account_id, {
        path,
        name,
        value,
        nvps,
        primaryKey,
        kVal,
      },
        async () => {
          await AccountsService.modifyJSON({
            ...payload,
            name: name === 'balance_amount' ? 'amount' : name,
          })
        }
      );

    } else {
      NavTabHelper.updateSingleNavTabDetails(royalty_account_id, accountsDetailsObj => {
        console.log('accountsDetailsObj', accountsDetailsObj)
        return {
          account: {
            ...accountsDetailsObj.account,
            [name]: value
          },
          ra: {
            ...accountsDetailsObj.ra,
            [name]: value
          },
          royalty_account: {
            ...accountsDetailsObj.royalty_account,
            [name]: value
          }
        };
      });

      const updatedAccountsDetailsRes = await MHTTPCL.modifyJSON(
        undefined,
        royalty_account_id,
        name,
        value,
        'l_royalty_accounts'
      );

      // If the Royalty List Items contains common keys, update them
      if ([
        'total_periods',
        'last_name',
        'json_data',
        'royalty_period_txt',
        'not_deletable',
        'total_period_bundles',
        'total_balances',
        'company_name',
        'total_contracts',
        'email1',
        'city',
        'identifier',
        'royalty_account_id',
        'master_account',
        'royalty_period',
        'b2b_flag',
        'first_name',
        'royalty_account_name',
        'master_royalty_account_id',
        'label_status_id',
        'label_status_colour',
        'label_status_name',
        'contact_id',
        'phone1',
        'contact_name'
      ].includes(name)) {
        commit(types.AccountsList.SET.ALL, {
          ...getters.accountsList,
          royalty_accounts: getters.accountsList.royalty_accounts?.map(e => {
            if (e.royalty_account_id === royalty_account_id) {
              return {
                ...e,
                [name]: value
              }
            }
            return e;
          })
        });

        return;
      }


    }

  },

  async [types.AccountsRelatedContacts.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("types.AccountsRelatedContacts.UPDATE.SINGLE", payload)

    const { contact, selectedAccountDetails } = payload;
    const { account } = selectedAccountDetails;
    const { royalty_account_id } = account;
    const key = 'contact_relation_id';
    const kVal = item[key];
    const table = 'contact_relations';

    NavTabHelper.updateSingleNavTabDetails(royalty_account_id, (accountsDetailsObj) => {
      return {
        contacts: accountsDetailsObj.contacts.map(e => {
          if (e.contact_relation_id == item.contact_relation_id) {
            return {
              ...e,
              [name]: value,
            };
          } else {
            return e;
          }
        })
      }
    })

    const modifiedRelease = await MHTTPCL.modifyJSON(undefined, kVal, name, value, table)

  },

  async [types.AccountsRelatedContacts.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log('payload', payload)
    const { contact, selectedAccountDetails } = payload;
    const { account } = selectedAccountDetails;
    const { royalty_account_id } = account;
    const { contact_relation_id } = contact;

    NavTabHelper.updateSingleNavTabDetails(royalty_account_id, accountsDetailsObj => {
      console.log('accountsDetailsObj', accountsDetailsObj)
      return {

        contacts: accountsDetailsObj.contacts.
          filter(e => e.contact_relation_id != contact_relation_id)
      }
    });

    const deletedContact = await AccountsService.deleteContactRelation(contact_relation_id)


  },


  async [types.AccountsRelatedContacts.SET.ALL]({ commit, getters, dispatch }, {
    contact_relations,
    external_table,
    external_id,
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(external_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        contacts: contact_relations
      };
    })
  },
  async [types.RoyaltyAccountsContracts.SET.ALL]({ commit, getters, dispatch }, {
    contracts,
    royalty_account_id,
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const data = NavTabHelper.getSingDet(royalty_account_id);
    console.log('data', data)
    if (data) {
      NavTabHelper.updateSingleNavTabDetails(royalty_account_id, (_, accountsDetailsObj) => {
        return {
          ...accountsDetailsObj,
          contracts: contracts,

        };
      })
    }

  },
  async [types.RoyaltyExternalUser.SET.ALL]({ commit, getters, dispatch }, {
    related_ext_users,
    royalty_account_id,
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(royalty_account_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        related_ext_users: related_ext_users,

      };
    })
  },
  async [types.RoyaltyAccountsMainContacts.SET.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { external_id, item_contact } = payload;
    NavTabHelper.updateSingleNavTabDetails(external_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        contact: item_contact,

      };
    })
  },

  async [types.RoyaltyAccountsStatements.FETCH.ALL]({ commit, getters, dispatch }, {
    royalty_account_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const raStatementsRes = await AccountsService.get_royalty_account_statements(royalty_account_id)
    console.log({ 'actions.js:429 raStatementsRes': raStatementsRes });

    NavTabHelper.updateSingleNavTabDetails(royalty_account_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        statement_data: raStatementsRes?.data?.royalty_periods || [],
      };
    })

    return raStatementsRes?.data?.royalty_periods || [];
  },
  async [types.RoyaltyAccountsStatements.SET.ALL]({ commit, getters, dispatch }, {
    statement_data,
    royalty_account_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(royalty_account_id, (_, accountsDetailsObj) => {
      console.log({ 'actions.js:544 accountsDetailsObj': accountsDetailsObj });
      return {
        ...accountsDetailsObj,
        statement_data: statement_data
      };
    })
  },
  async [types.RoyaltyAccountsStatements.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { royalty_account_id, royalty_period_id, royalty_period_bundle_id } = payload;
    console.log({ 'actions.js:553 payload': payload });

    NavTabHelper.updateSingleNavTabDetails(`${royalty_account_id}`, (accountsDetailsObj) => {

      console.log('Filtered Statement Data', _, accountsDetailsObj, accountsDetailsObj?.statement_data, accountsDetailsObj?.statement_data?.filter(e => `${e.royalty_period_id}` !== `${royalty_period_id}`) || []);

      return {
        ...accountsDetailsObj,
        statement_data: accountsDetailsObj?.statement_data?.filter(e => `${e.royalty_period_id}` !== `${royalty_period_id}`) || []
      };
    });

    const deletedStatement = await AccountsService.removeRoyaltyPeriod({
      royalty_period_id,
      royalty_period_bundle_id
    });


    // Delete from Sidewindow Tabs

    dispatch(`${RoyaltyStoreNamespace}/${RoyaltyModuleTypes.StatementDetails.DELETE.SINGLE}`, {
      royalty_period_id,
    }, { root: true });

    // Delete From Royalty Statements List

    dispatch(`${RoyaltyStoreNamespace}/${RoyaltyModuleTypes.DefaultStatementList.SET.ALL}`, {
      royalty_period_id,
      noDatabaseUpdate: true
    }, { root: true });

  },
  async [types.RoyaltyAccountsMechanicalContract.SET.ALL]({ commit, getters, dispatch }, {
    statement_data,
    royalty_account_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(royalty_account_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        statement_data: statement_data
      };
    })
  },
  async [types.RoyaltyAccountsBalances.SET.ALL]({ commit, getters, dispatch }, { balances, royalty_account_id }) {
    console.log('royalty_account_id', royalty_account_id)
    console.log('balances', balances)
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(royalty_account_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        balances: balances
      };
    })
  },
  async [types.RoyaltyAccountsBalances.INSERT.MULTIPLE]({ commit, getters, dispatch }, payload) {

    const { royalty_account_id, start } = payload;
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const res = await AccountsService.royalty_account_balances(royalty_account_id, start);

    console.log(getters.accountsDetails, "RES:::::::::", res)


    NavTabHelper.updateSingleNavTabDetails(royalty_account_id, (_, accountsDetailsObj) => {

      return {
        ...accountsDetailsObj,
        balances: [...getters.accountsDetails[royalty_account_id].balances, ...res.data.balances]
      };
    })
  },
  async [types.RoyaltyAccountsPayments.SET.ALL]({ commit, getters, dispatch }, {
    payments,
    royalty_account_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(royalty_account_id, (_, accountsDetailsObj) => {
      return {
        ...accountsDetailsObj,
        payments: payments
      };
    })
  },
  // Related Files
  async [types.SET_ROYALTY_ACCOUNT_FILES](
    { dispatch, getters },
    { files, externalId, externalTable }
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const royalty_account_id = externalId;
    NavTabHelper.setSingleNavTabDetails(
      royalty_account_id,
      (_, accountsDetailsObj) => {
        return {
          ...accountsDetailsObj,
          files
        };
      }
    );
  },
  async [types.INSERT_ROYALTY_ACCOUNT_BALANCE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { royalty_account_id } = payload;
    const res = await AccountsService.addNewRoyaltyAccountBalance(royalty_account_id);
    console.log('balances', res.data.balances)

    NavTabHelper.updateSingleNavTabDetails(
      royalty_account_id,
      (_, accountsDetailsObj) => {
        console.log('accountsDetailsObj', accountsDetailsObj);
        return {
          ...accountsDetailsObj,
          balances: [...res.data.balances] || []
        };
      }
    );
  },
}
